import React, { Component } from 'react';
import {observer} from 'mobx-react'
import styles from './index.css';
import notYet from './notYet.png';
import {Link} from 'react-router-dom';
import fonts from '../../../../iconfonts.css';
import {presets} from '../../../stores/index';
import { Slider } from 'react-compound-slider'
import CompoundSlider from "../../CompoundSlider";


@observer
export default class EquipResults extends Component {



    render() {

        const ebitda = {
            "wheat":4.94,
            "rape":6.20,
            "soy":5.42,
            "sunflower":9.16,
            "corn":9.79
        };

        let cultureTotal = presets.culturePlan.wheat + presets.culturePlan.rape + presets.culturePlan.soy + presets.culturePlan.sunflower + presets.culturePlan.corn;
        cultureTotal = cultureTotal ===0 ? 1 : cultureTotal;
        let totalWeight = presets.storageEquip.reduce((sum,current)=>(sum+(+current.capacity*current.quantity)),0);
        let turnover = (cultureTotal / totalWeight).toFixed(1);
        if (!cultureTotal || !totalWeight) turnover = '0.0';

        const input = presets.inputEquip.filter((item)=>item.quantity);
        const output = presets.outputEquip.filter((item)=>item.quantity);
        const cleaning = presets.cleaningEquip.filter((item)=>item.quantity);
        const drying = presets.dryingEquip.filter((item)=>item.quantity);
        const storage = presets.storageEquip.filter((item)=>item.quantity);
        const totalCost = ()=>{
            let result = 0;
            input.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))})
            output.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))})
            cleaning.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))})
            drying.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))})
            storage.forEach((item)=>{result+=item.quantity*(+item.price.replace(/[.| ]/gim,''))})
            return result + presets.infrastructure;
        };
        const totalStorage = storage.reduce((sum,current)=>(sum+(+current.capacity*current.quantity)),0);
        const capitalTurnover = ()=>{
            let result = 0;
            let holdingPrices = {
                "wheat": 1.39,
                "rape": 1.67,
                "soy": 1.50,
                "sunflower": 3.05,
                "corn": 1.39,
            };
            for(let key in presets.culturePlan){
                result+=presets.culturePlan[key]*ebitda[key];
                result+=presets.culturePlan[key]*(presets.cultureHoldingPlan[key]/30)*holdingPrices[key];

            }
            if(totalCost() !== 0) {
                return (result / totalCost() * 100).toFixed(2);
            }
            return (0).toFixed(2);
        };

        return (
            <div className={styles.equipResult}>
                <h3>ВИ ОБРАЛИ:</h3>
                <div className={styles.notYet}
                     style={{display:(presets.region || input.length || output.length || cleaning.length || drying.length || storage.length)?'none':''}}>
                    <p>Покищо нічого не обрано</p>
                    <img src={notYet} alt="нічого не обрано" />
                    <p className={styles.hint}>Для створення елеватору оберіть всі елементи елеватору зі списка з вкладок в лівій частині екрану</p>
                </div>
                <div className={styles.scrollContainer}>
                    <div className={styles.scrollableCheck}>
                        {presets.region ?
                            <div className={styles.equipResultSection}>
                                <h4>Регіон розміщення</h4>
                                <p>{presets.region.name}</p>
                            </div>
                            :
                            null
                        }
                        <SelectedEquipment arr={input} title="Лінії приймання"/>
                        <SelectedEquipment arr={cleaning} title="Обладнання для очистки"/>
                        <SelectedEquipment arr={drying} title="Обладнання для сушки"/>
                        <SelectedEquipment arr={storage} title="Потужності зберігання"/>
                        <SelectedEquipment arr={output} title="Лінії відгрузки"/>
                        {(presets.region && storage.length) ?
                            <div className={styles.equipResultSection}>
                                <h4>План объёмов культур (тонн / %)</h4>
                                <div className={styles.equipCheckCultures}>
                                    <div className={styles.equipCheckCulture}>
                                        <div className={styles.cultureCircle + ' ' + styles.wheat}><i className={fonts.wheat}/></div>
                                        <p>{Math.floor(presets.culturePlan.wheat)}</p>
                                        <p>{(presets.culturePlan.wheat/cultureTotal*100).toFixed(1)}%</p>
                                    </div>
                                    <div className={styles.equipCheckCulture}>
                                        <div className={styles.cultureCircle + ' ' + styles.rape}><i className={fonts.rape}/></div>
                                        <p>{Math.floor(presets.culturePlan.rape)}</p>
                                        <p>{(presets.culturePlan.rape/cultureTotal*100).toFixed(1)}%</p>
                                    </div>
                                    <div className={styles.equipCheckCulture}>
                                        <div className={styles.cultureCircle + ' ' + styles.soy}><i className={fonts.soy}/></div>
                                        <p>{Math.floor(presets.culturePlan.soy)}</p>
                                        <p>{(presets.culturePlan.soy/cultureTotal*100).toFixed(1)}%</p>
                                    </div>
                                    <div className={styles.equipCheckCulture}>
                                        <div className={styles.cultureCircle + ' ' + styles.sunflower}><i className={fonts.sunflower}/></div>
                                        <p>{Math.floor(presets.culturePlan.sunflower)}</p>
                                        <p>{(presets.culturePlan.sunflower/cultureTotal*100).toFixed(1)}%</p>
                                    </div>
                                    <div className={styles.equipCheckCulture}>
                                        <div className={styles.cultureCircle + ' ' + styles.corn}><i className={fonts.corn}/></div>
                                        <p>{Math.floor(presets.culturePlan.corn)}</p>
                                        <p>{(presets.culturePlan.corn/cultureTotal*100).toFixed(1)}%</p>
                                    </div>
                                </div>
                                <div className={styles.finalResultsItem}>
                                    <p>Всього заплановано:</p>
                                    <p>{cultureTotal} т.</p>
                                </div>
                            </div>

                            :
                            null
                        }

                    </div>
                </div>
                <div className={styles.finalResults}>
                    <h3>У ОБРАНІЙ КОНФІГУРАЦІЇ:</h3>
                    <div className={styles.finalResultsItem}>
                        <p>Об'єм приймання в день:</p>
                        <p>{(input.reduce((sum,current)=>(sum+(+current.capacity*current.quantity)),0)*24).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} т.</p>
                    </div>
                    <div className={styles.finalResultsItem}>
                        <p>Сумарний об'єм зберігання:</p>
                        <p>{totalStorage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} т.</p>
                    </div>
                    <div className={styles.finalResultsItem}>
                        <p>Кількість обертів за сезон:</p>
                        <p>{turnover}</p>
                    </div>
                    <div className={styles.finalResultsItem}>
                        <p>Оцінка повернення капиталу:</p>
                        <h2 style={{transition:'500ms',color:capitalTurnover() < 15 ? '#FF0000' : "#7ed321" }}>
                            {capitalTurnover()}%
                        </h2>
                    </div>
                    <div className={styles.rangeSlider}>
                        <h3>ВАРТІСТЬ ІНФРАСТРУКТУРИ:</h3>
                        <CompoundSlider width={"100%"}/>
                    </div>
                    <div className={styles.finalResultsItem}>
                        <p>Вартість елеватора:</p>
                        <h2>$ {totalCost().toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}</h2>
                    </div>
                </div>
                <br />
                <Link to="/app" className={styles.button +
                ((presets.region && input.length && output.length && cleaning.length && drying.length && storage.length)?
                    '' : ' ' + styles.disabled)} onClick={(e)=>{
                    (presets.region && input.length && output.length && cleaning.length && drying.length && storage.length)?
                        presets.setElevatorsData()
                        :
                        e.preventDefault();
                }}>СТВОРИТИ ЕЛЕВАТОР</Link>
            </div>
        );
    }
}

const SelectedEquipment = (props) =>{
    if(props.arr.length){
        return (
            <div className={styles.equipResultSection}>
                <h4>{props.title}</h4>
                {props.arr.map((item,i)=>{
                    return(
                        <div className={styles.equipCheckItem} key={i}>
                            <p>{item.name}</p>
                            <p>{item.quantity}шт</p>
                            <p>${(+item.price.replace(/[.| ]/gim,'')*item.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</p>
                        </div>
                    )})}
            </div>
        )
    }
    return null;
};

// let culturePlan = {
//     "wheat":106260,
//     "rape":13380,
//     "soy":17280,
//     "sunflower":12480,
//     "corn":99660
// };


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/EquipResults/index.js